import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDoctorDashboardData } from '../../../../redux/reducers/doctorDashboardSlice';
const ConsultationLineChartWithFilter = () => {
  const dispatch = useDispatch();
  const { weekConsultationCounts, monthlyConsultationCounts, yearlyConsultationCounts } = useSelector(
    (state) => state.doctorDashboard
  );

  const [view, setView] = useState('Weekly');
  const [selectedVet, setSelectedVet] = useState('');
  const [chartData, setChartData] = useState({ categories: [], series: [] });
  const [vetNames, setVetNames] = useState([]);

  useEffect(() => {
    dispatch(fetchDoctorDashboardData());
  }, [dispatch]);

  // Extract vet names once data is available
  useEffect(() => {
    if (!weekConsultationCounts.length) return;

    const allDoctors = new Set(weekConsultationCounts.map(d => d.doctor));
    setVetNames([...allDoctors]);
    setSelectedVet([...allDoctors][0]);
  }, [weekConsultationCounts]);

  // Update chart when view or selectedVet changes
  useEffect(() => {
    if (!selectedVet || !weekConsultationCounts.length) return;

    const dataMap = {
      Weekly: weekConsultationCounts,
      Monthly: monthlyConsultationCounts,
      Yearly: yearlyConsultationCounts,
    };

    const viewData = dataMap[view] || [];
    const doctorEntry = viewData.find((d) => d.doctor === selectedVet);
    if (!doctorEntry) {
      setChartData({ categories: [], series: [] });
      return;
    }

    const categories = Object.keys(doctorEntry).filter((k) => k !== 'doctor');
    const values = categories.map((key) => doctorEntry[key]);

    setChartData({
      categories,
      series: [
        {
          name: 'Consultations',
          data: values,
        },
      ],
    });
  }, [view, selectedVet, weekConsultationCounts, monthlyConsultationCounts, yearlyConsultationCounts]);

  const chartOptions = {
    chart: {
      id: 'line-chart',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: 'straight',
      width: 2,
    },
    markers: {
      size: 6,
      strokeWidth: 2,
      strokeColors: '#fff',
      hover: { size: 7 },
    },
    xaxis: {
      categories: chartData.categories,
    },
    yaxis: {
      min: 0,
      tickAmount: 4,
    },
    colors: ['#0056b3'],
    grid: {
      borderColor: '#e0e0e0',
    },
  };

  return (
  <Box>
    {/* Top-right toggle buttons OUTSIDE the main chart box */}
    <Box display="flex" justifyContent="flex-end" mb={1}>
      <ToggleButtonGroup
  value={view}
  exclusive
  onChange={(_, val) => val && setView(val)}
  size="small"
  sx={{
    backgroundColor: '#f0f2f5',
    borderRadius: '12px',

    // Styles for all grouped toggle buttons
    '& .MuiToggleButtonGroup-grouped': {
      borderRadius: '7px',
      borderColor: 'transparent',
      color: '#333',
      transition: 'none', // remove hover effect if needed

      // Only apply to selected button
      '&.Mui-selected': {
        backgroundColor: '#005EB8',
        color: '#fff',
      },
    },
  }}
>
  <ToggleButton value="Weekly">Week</ToggleButton>
  <ToggleButton value="Monthly">Month</ToggleButton>
  <ToggleButton value="Yearly">Year</ToggleButton>
</ToggleButtonGroup>

    </Box>

    {/* Chart Card */}
    <Box p={3} bgcolor="#fff" borderRadius="16px" boxShadow={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
  <Typography variant="subtitle1" fontWeight="bold">
    Consultations Done per Vet ({view})
  </Typography>

  <FormControl size="small" sx={{ minWidth: 180 }}>
    <InputLabel>Vet</InputLabel>
    <Select
      value={selectedVet}
      label="Vet"
      onChange={(e) => setSelectedVet(e.target.value)}
    >
      {vetNames.map((name, index) => (
        <MenuItem key={index} value={name}>
          {name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Box>


      <Chart options={chartOptions} series={chartData.series} type="line" height={320} />
    </Box>
  </Box>
);

};

export default ConsultationLineChartWithFilter;